export default require('./Button-Group.vue').default